export const openSmartBill = () => {
  const newWindow = window.open(
    'https://cloud.smartbill.ro/raport/proforme/',
    '_blank',
    'noopener,noreferrer'
  );
  if (newWindow) newWindow.opener = null; // https://mathiasbynens.github.io/rel-noopener/, https://www.jitbit.com/alexblog/256-targetblank---the-most-underestimated-vulnerability-ever/
};
